import { render, staticRenderFns } from "./AddCat.vue?vue&type=template&id=5a741d34&scoped=true&"
import script from "./AddCat.vue?vue&type=script&lang=js&"
export * from "./AddCat.vue?vue&type=script&lang=js&"
import style0 from "./AddCat.vue?vue&type=style&index=0&id=5a741d34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a741d34",
  null
  
)

export default component.exports